/**
 * initialize event listener for quantity modifier button
 */
const postcodeInputContainer = document.querySelector(`.popup-postcode__form postcode-update`);

const hidePostcodeError = function() {
  postcodeInputContainer._updateErrorMessage();
}

export function displayPostCodePopup() {
  var popup = document.querySelector('.popup-postcode-wrapper');
  document.body.classList.add('overlay-active');
  popup.style.display = 'block';
  postcodeInputContainer.focus();
}

export function hidePostCodePopup() {
  var popup = document.querySelector('.popup-postcode-wrapper');
  document.body.classList.remove('overlay-active');
  popup.style.display = 'none';
  postcodeInputContainer.clearInput();
  hidePostcodeError();
}

function triggerSubmit() {
  postcodeInputContainer.triggerPostcodeUpdate();
}

export const postcodePopup = (function () {
  'use strict';
  var init = function () {
    var postcodeLink = document.querySelectorAll('.postcode-link');

    var popupClose = document.querySelector('.popup-postcode-close');
    var popup = document.querySelector('.popup-postcode-wrapper');
    var popupSubmitButton = document.querySelector(`.popup-postcode__button`);
    var pageOverlay = document.getElementById("page-overlay");

    if (pageOverlay) {
      pageOverlay.addEventListener("click", hidePostCodePopup);
    }

    if((popupClose !== null) && (popup !== null)) {
      popupClose.onclick = hidePostCodePopup
    }

    if(postcodeLink !== null) {
      postcodeLink.forEach(function(element) {
        element.onclick = displayPostCodePopup;
      });
    }
    popupSubmitButton.addEventListener(`click`, triggerSubmit)
  };

  return {
    init: init
  };

});

